import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { FirebaseService } from '@lib/core/services/firebase.service';

@Component({
  selector: 'hm-app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private readonly firebaseService = inject(FirebaseService);

  ngOnInit(): void {
    this.requestFirebasePushNotifications();
  }

  private requestFirebasePushNotifications() {
    this.firebaseService.requestNotificationsPermission();
    this.firebaseService.listen();
  }
}
